module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-api-middleware/node_modules/core-js/library/modules/$.redefine.js
// module id = 256
// module chunks = 1 2 3